import { Col, Container, Row } from 'react-bootstrap';
import dayjs from 'dayjs';

import constants from '@lib/constants';

import './footer.scss';


function Footer() {
    return (
        <footer>
            <Container>
                <div className="content">
                    <div className="logo">
                        <img
                            src="/vf-logo.png"
                            title="Voipfone"
                            alt="Voipfone"
                        />
                    </div>

                    <Row>
                        <Col md={6} lg={4}>
                            <p className="text-yellow text-md">All About Voipfone</p>

                            <p>
                                <a href={`${constants.BASE_VF_URL}/about/testimonials`}>
                                    Case Studies</a><br />
                                <a href={`${constants.BASE_VF_URL}/about/press/awards`}>
                                    Press &amp; Awards</a><br />
                                <a href={`${constants.BASE_VF_URL}/about/network`}>
                                    Our Network</a><br />
                                <a href={`${constants.BASE_VF_URL}/guides/what-is-voip`}>
                                    What is VoIP?</a><br />
                                <a href={`${constants.BASE_VF_URL}/about/jobs`}>
                                    Jobs at Voipfone</a><br />
                                <a href={constants.BASE_BLOG_URL} target="_blank" rel="noreferrer">
                                    Voipfone Blog</a><br />
                            </p>

                            <p className="text-yellow text-md">Products &amp; Services</p>

                            <p>
                                <a href={`${constants.BASE_VF_URL}/plans/comparison`}>
                                    Voipfone Plans</a><br />
                                <a href={`${constants.BASE_VF_URL}/services/uk-phone-numbers`}>
                                    Telephone Numbers</a><br />
                                <a href={`${constants.BASE_VF_URL}/services/pbx`}>
                                    Hosted PBX Services</a><br />
                                <a href={`${constants.BASE_VF_URL}/services`}>
                                    Standard Features</a><br />
                                <a href={`${constants.BASE_VF_URL}/services/broadband`}>
                                    Business Broadband</a><br />
                                <a href={`${constants.BASE_VF_URL}/support/guides/software/softphone/softphone-desktop`}>
                                    Softphone Download</a><br />
                            </p>
                        </Col>
                        <Col md={6} lg={4}>
                            <p className="text-yellow text-md">Customer Services</p>

                            <p>
                                <a href={constants.BASE_CP_URL} target="_blank" rel="noreferrer">
                                    Control Panel Login</a><br />
                                <a href={`${constants.BASE_VF_URL}/call-cost-calculator`} target="_blank" rel="noreferrer">
                                    Call Cost Calculator</a><br />
                                <a href={`${constants.BASE_VF_URL}/about/service-numbers`}>
                                    Service Numbers</a><br />
                                <a href={constants.BASE_STATUS_URL} target="_blank" rel="noreferrer">
                                    Service Status</a><br />
                                <a href={`${constants.BASE_VF_URL}/support/faq`}>
                                    FAQs</a><br />
                                <a href={`${constants.BASE_VF_URL}/contact`}>
                                    Contact Us</a>
                            </p>

                            <p className="text-yellow text-md">Terms &amp; Conditions</p>

                            <p>
                                <a href={`${constants.BASE_VF_URL}/policies/terms`}>
                                    Terms &amp; Conditions</a><br />
                                <a href={`${constants.BASE_VF_URL}/policies/usage`}>
                                    Usage Policy</a><br />
                                <a href={`${constants.BASE_VF_URL}/policies/code-of-practice`}>
                                    Code of Practice</a><br />
                                <a href={`${constants.BASE_VF_URL}/policies/complaints`}>
                                    Complaint &amp; Dispute Resolution</a><br />
                                <a href={`${constants.BASE_VF_URL}/policies/privacy`}>
                                    Privacy Notice</a><br />
                                <a href={`${constants.BASE_VF_URL}/policies/cookies`}>
                                    Cookie Policy</a>
                            </p>
                        </Col>
                        <Col md={6} lg={4}>
                            <p className="text-yellow text-md">Contact Us</p>

                            <p className="contact">
                                <strong>Head Office</strong><br />
                                iNet Telecoms&reg; Ltd<br />
                                Sovereign House<br />
                                227 Marsh Wall<br />
                                London<br />
                                E14 9SD<br />
                                United Kingdom
                            </p>

                            <p>
                                Email: {constants.VF_EMAIL}<br />
                                Telephone: {constants.VF_TEL}<br />

                                <a
                                    href="https://www.facebook.com/voipfone"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="social"
                                >
                                    <img
                                        src="/facebook.png"
                                        title="Facebook"
                                        alt="Facebook"
                                        width="30"
                                        height="30"
                                        style={{ margin: '4px' }}
                                    />
                                </a>

                                <a
                                    href="https://x.com/voipfone"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="social"
                                >
                                    <img
                                        src="/x.png"
                                        title="X"
                                        alt="X"
                                        width="30"
                                        height="30"
                                        style={{ margin: '4px' }}
                                    />
                                </a>

                                <a
                                    href="https://www.instagram.com/voipfone"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="social"
                                >
                                    <img src="/instagram.png"
                                        title="Instagram"
                                        alt="Instagram"
                                        width="30"
                                        height="30"
                                        style={{ margin: '4px' }}
                                    />
                                </a>

                                <a
                                    href="https://www.youtube.com/voipfone"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="social"
                                >
                                    <img
                                        src="/youtube.png"
                                        title="YouTube"
                                        alt="YouTube"
                                        width="30"
                                        height="30"
                                        style={{ margin: '4px' }}
                                    />
                                </a>

                                <a
                                    href="https://www.linkedin.com/company/voipfone"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="social"
                                >
                                    <img
                                        src="/linkedin.png"
                                        title="LinkedIn"
                                        alt="LinkedIn"
                                        width="30"
                                        height="30"
                                        style={{ margin: '4px' }}
                                    />
                                </a>
                            </p>

                            <p>
                                <a
                                    href="https://commscouncil.uk"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img
                                        src="/comms-council.png"
                                        title="Comms Council UK"
                                        alt="Comms Council UK"
                                        width="145"
                                        height="59"
                                    />
                                </a>
                            </p>
                        </Col>
                    </Row>
                </div>
                <div className="copyright">
                    <p>
                        Copyright 2004 - {dayjs().format('YYYY')},
                        iNet Telecoms &reg; Ltd.
                        All rights reserved
                    </p>
                </div>
            </Container>
        </footer>
    );
}


export default Footer;
